import { find } from 'ramda';

export const tournamentTypes = [
  'CUP_MATCHES',
  'LEAGUE_MATCHES',
  'SPRING_TRAINING',
  'CHALLENGE',
  'POSTSEASON',
  'ALL_STAR',
  'OTHER',
];
export const tournamentTeamTypes = [
  'UNDER_ELEMENTARY_SCHOOL',
  'ELEMENTARY_SCHOOL',
  'JUNIOR_HIGH_SCHOOL',
  'SENIOR_HIGH_SCHOOL',
  'COLLEGE',
  'PROFESSION',
  'SOCIETY',
  'NONE',
  'OTHER',
];
export const tournamentPlayerTypes = ['NONE', 'WOMEN', 'MEN'];
export const tournamentBallTypes = ['ORDINARY', 'RUBBER'];
export const tournamentBatTypes = ['WOODEN', 'METAL', 'NONE'];

export const gameStatus = ['SCHEDULED', 'PLAYING', 'FINISHED'];
export const gameFinishedStatus = ['CALLED', 'FORFEITED', 'ADJUDGED', 'SUSPENDED', 'NORMAL'];
export const recordTypes = {
  BATTER: ['GWRBI', 'MVP', 'SP_RECORD'],
  PITCHER: ['W', 'L', 'H', 'SV', 'BS', 'MVP', 'SP_RECORD'],
};

export const getTeamInitState = () => {
  return {
    team_name: '',
    scores: [],
    runs: 0,
    hits: '0',
    errors: '0',
    batters: [],
    pitchers: [],
    players: [],
    records: [],
    runs_without_innings: false,
    record_battings: false,
    record_pitchings: false,
    record_fieldings: false,
  };
};

export const getGameInitState = () => {
  return {
    uniqid: '',
    info: {
      status: '',
      finished_status: '',
      location_uniqid: '',
      time: {
        scheduled_start_at: '',
        started_at: '',
        ended_at: '',
      },
      nodes: [],
      group: '',
      innings: '',
    },
    away: getTeamInitState(),
    home: getTeamInitState(),
  };
};

export const boxBattingColumns = [
  'player',
  'is_PH',
  'order',
  'PA',
  'AB',
  'H',
  'TWOB',
  'THREEB',
  'HR',
  'SO',
  'BB',
  'IBB',
  'HBP',
  'SF',
  'SH',
  'GIDP',
  'FC',
  'E',
  'FO',
  'GO',
  'SB',
  'CS',
  'R',
  'RBI',
];

export const boxPitchingColumns = [
  'player',
  'order',
  'IPOut',
  'NP',
  'BF',
  'H',
  'HR',
  'BB',
  'IBB',
  'HB',
  'SO',
  'WP',
  'BK',
  'R',
  'ER',
];

export const boxFieldingColumns = ['player', 'position', 'order', 'TC', 'PO', 'A', 'E', 'DP', 'PB', 'SB', 'CS'];

export const fieldingPositions = ['P', 'C', '1B', '2B', '3B', 'SS', 'LF', 'CF', 'RF', 'DH', 'PH', 'PR'];

export const initInGamePlayersOrder = (inGameplayers, batters, pitchers) => {
  const players = [];
  const appendPlayers = (bps) => {
    bps.forEach((bp) => {
      const inGamePlayer = find((p) => p.info.uniqid === bp.player.uniqid, inGameplayers);
      if (!inGamePlayer) {
        return;
      }

      const player = find((p) => p.info.uniqid === bp.player.uniqid, players);
      if (player) {
        return;
      }

      players.push(inGamePlayer);
    });
  };
  appendPlayers(batters);
  appendPlayers(pitchers);

  return players;
};

export const currencyDisplay = {
  NTD: {
    text: 'NT$',
    toFixed: 0,
  },
};

export const playerDefaultColumns = {
  first_position: 'POSITION',
  second_position: 'POSITION',
  p_hand: 'HAND',
  b_hand: 'HAND',
};

export const playerPositionOptions = ['UNSET', 'P', 'C', '1B', '2B', '3B', 'SS', 'LF', 'CF', 'RF', 'DH', 'IF', 'OF'];
export const playerHandOptions = ['UNSET', 'R', 'L', 'BOTH'];
